import React, { useState } from 'react';
import css from './СreateInputArrowModal.module.scss';
import ArrowIcon from '../../images/arrow-icon.svg';
import ReverseArrowIcon from '../../images/reverse-arrow-icon.svg';
import { WorkshopGroupTagsDropdown } from './groupTagsDropdown/WorkshopGroupTagsDropdown';
import { useTagCountText } from '../services/useTagCountText';

interface CreateInputArrowModalProps {
	text: string,
	inputData?: {
		id: string,
		name: string
	}[],
	choicedItemsId: string[],
	onAddChoicedItem: (value: string) => void,
	onRemoveChoicedItem: (value: string) => void,
}

const CreateInputArrowModal: React.FC<CreateInputArrowModalProps> = ({
	text,
	inputData,
	choicedItemsId,
	onAddChoicedItem,
	onRemoveChoicedItem,
}: CreateInputArrowModalProps) => {
	const [areHiddenShowed, setAreHiddenShow] = useState(false);

	CreateInputArrowModal.defaultProps = {
		inputData: undefined,
	};

	const onShowHidden = () => {
		if (inputData) {
			setAreHiddenShow(!areHiddenShowed);
		}
	};

	const textColor = choicedItemsId.length > 0 ? css.textBlack : css.text;

	return (
		<div className={css.wrapper}>
			<div
				className={css.inp}
				onClick={onShowHidden}
				role="presentation"
			>
				<div className={textColor}>
					{useTagCountText(choicedItemsId.length)}
				</div>
				<div>
					{
						choicedItemsId.length === 0 || !areHiddenShowed
							? <ArrowIcon />
							: <ReverseArrowIcon />
					}
				</div>
			</div>
			{
				areHiddenShowed && inputData && inputData.length > 0 && (
					<div className={css.hiddenBlock}>
						<WorkshopGroupTagsDropdown
							groupID={inputData[0].id}
							onAddChoicedItem={onAddChoicedItem}
							onRemoveChoicedItem={onRemoveChoicedItem}
							selectedItems={choicedItemsId}
						/>
					</div>
				)
			}
		</div>
	);
};

export default CreateInputArrowModal;
